import React from "react";
import { StyleSheet, TouchableOpacity, View } from "react-native";

import Text from "components/Text";
import Shadow from "components/Shadow";
import GridView from "components/GridView";
import CheckboxIcon from "components/CheckboxIcon";

import { sizes, colors } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";
import tinycolor from "tinycolor2";
import { sn } from "utils";
import Icon from "./Icon";

const PermissionSection: React.FC<PermissionSectionT> = ({
  section,
  onChange,
  selected,
}) => {
  const {
    company: { color },
  } = useRecoilValue(authAtom);

  const permissionsIds = section?.permission?.map((e) => e.id);

  const onChangeSectionStatus = () => {
    const status = permissionsIds.every((e) => selected.includes(e));

    let newSelected = [...selected];
    if (status) {
      newSelected = newSelected.filter((e) => !permissionsIds.includes(e));
    } else {
      newSelected = [
        ...newSelected,
        ...permissionsIds.filter((e) => !newSelected.includes(e)),
      ];
    }
    onChange && onChange(newSelected);
  };

  const _renderPermissionsItem = (permission: PermissionT) => {
    const status = selected.includes(permission.id) ? 1 : 0;

    const onChangePermissionStatus = () => {
      let newSelected = [...selected];

      if (status) {
        newSelected = newSelected.filter((e) => e !== permission.id);
      } else {
        newSelected.push(permission.id);
      }
      onChange && onChange(newSelected);
    };

    return (
      <TouchableOpacity
        style={{ flex: 1 }}
        activeOpacity={sizes.tapOpacity}
        onPress={onChangePermissionStatus}
      >
        <Shadow
          shadow={{ radius: 1, opacity: 1 }}
          style={{
            ...styles.permission,
            backgroundColor:
              status === 1
                ? tinycolor(color).lighten(50).toString()
                : "#f9f9f9",
          }}
        >
          {status === 1 && (
            <View
              style={{
                position: "absolute",
                top: -5,
                right: -5,
                width: 20,
                height: 20,
                borderRadius: 20,
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: colors.white,
                borderWidth: 1,
                borderColor: tinycolor(color).lighten(45).toString(),
              }}
            >
              <Icon size={sn(12)} name="check" color={color} />
            </View>
          )}
          <Text
            color={status === 1 ? color : colors.text.normal}
            size={"sm"}
            weight="bold"
          >
            {permission?.name}
          </Text>
        </Shadow>
      </TouchableOpacity>
    );
  };

  const sectionStatus = permissionsIds.every((e) => selected.includes(e))
    ? 1
    : permissionsIds.some((e) => selected.includes(e))
    ? -1
    : 0;

  return (
    <Shadow
      shadow={{ radius: 1, opacity: 8 }}
      style={{
        ...styles.container,
        borderColor:
          sectionStatus === 0
            ? colors.white
            : tinycolor(color)
                .lighten(sectionStatus === 1 ? 50 : 52)
                .toString(),
      }}
    >
      <TouchableOpacity
        activeOpacity={0.5}
        style={styles.header}
        onPress={onChangeSectionStatus}
      >
        <CheckboxIcon status={sectionStatus} />
        <Text
          color={sectionStatus !== 0 ? color : colors.text.normal}
          weight="bold"
        >
          {" "}
          {section?.name}
        </Text>
      </TouchableOpacity>

      {section?.permission?.length > 0 && (
        <GridView
          gridHeight={sn(50, 60, 60, 65)}
          spacing={sizes.space}
          numberOfCol={sn(4, 5, 6, 7)}
          data={section?.permission}
          renderItem={_renderPermissionsItem}
        />
      )}
    </Shadow>
  );
};

export default PermissionSection;

const styles = StyleSheet.create({
  container: {
    width: "100%",
    backgroundColor: "#fff",
    borderRadius: sizes.radius.xl,
    marginVertical: sizes.space,
    borderWidth: 1,
  },

  header: {
    alignItems: "center",
    padding: sizes.space,
    flexDirection: "row-reverse",
  },

  permission: {
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.white,
    borderRadius: sizes.radius.lg,
  },
});
